export const TOOL_TITLE =
  "Medicaid-Covered Prescription Fills and Refills for Medications to Treat Opioid Use Disorder";

export const MEDICATION_NAMES = [
  { label: "All", value: "all" },
  { label: "Naltrexone", value: "naltrexone" },
  { label: "Naloxone", value: "naloxone" },
  { label: "Buprenorphine", value: "buprenorphine" }
];

export const BREAKDOWN_NAMES = MEDICATION_NAMES.filter(({ value }) => value !== "all")
  .map(({ value }) => [`${value}_brand`, `${value}_generic`])
  .flat();

export const BRANDS = [
  { label: "All", value: "all" },
  { label: "Brand", value: "brand" },
  { label: "Generic", value: "generic" }
];

export const METRICS = [
  {
    label: "Total number of prescriptions",
    metric: "numberofprescriptions",
    full_name: "Number of prescription fills",
    unit: "INT"
  },
  {
    label: "Prescriptions per 1,000 Medicaid enrollees",
    metric: "percap_rx",
    full_name: "Prescription fills per 1,000 Medicaid enrollees",
    unit: "DECIMAL_ONE"
  },
  {
    label: "Prescriptions per 1,000 Medicaid enrollees with opioid use disorder",
    metric: "percapoud_rx",
    full_name: "Prescription fills per 1,000 Medicaid enrollees with opioid use disorder",
    unit: "DECIMAL_ONE"
  }
];

export const YEARS = [
  "2010",
  "2011",
  "2012",
  "2013",
  "2014",
  "2015",
  "2016",
  "2017",
  "2018",
  "2019",
  "2020",
  "2021",
  "2022",
  "2023",
  "2024",
  "2025"
];

const quarters_expected = ["Q1", "Q2", "Q3", "Q4"];

export const QUARTERS = YEARS.flatMap((year) => quarters_expected.map((q) => `${year} ${q}`));

export const ALL_TIMES = [...YEARS, ...QUARTERS].sort((a, b) => {
  const aParts = a.toString().split(" ");
  const bParts = b.toString().split(" ");
  const aYear = parseInt(aParts[0], 10);
  const bYear = parseInt(bParts[0], 10);
  if (aYear !== bYear) {
    return aYear - bYear;
  }
  if (aParts.length === 1) return -1;
  if (bParts.length === 1) return 1;
  const aQuarter = parseInt(aParts[1].substring(1), 10);
  const bQuarter = parseInt(bParts[1].substring(1), 10);
  return aQuarter - bQuarter;
});
